import React from 'react';
import Rating from '@material-ui/lab/Rating';
import { RecruitmentSearchReview } from 'src/client/generated';

type Props = {
  review: RecruitmentSearchReview;
};

export const Review = ({ review }: Props) => {
  return (
    <>
      <Rating value={review?.rate} precision={0.1} size="small" readOnly />
      <span className="text-sm font-bold ml-1">{review?.rate}</span>
      <span className="text-xs text-gray3 ml-1">{review?.description}</span>
    </>
  );
};
